import * as React from "react";
function SvgCircleCross(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <g
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      >
        <circle cx={16} cy={16} r={15} />
        <path d="M10 22l12-12M10 10l12 12" />
      </g>
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgCircleCross);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
